import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { Button } from "react-bootstrap";
// import Loader from "../../ui/Loader";
import SelectDropdown from "../../components-react/SelectDropdown";
import { leadCloseStatus } from "../../common-data/DropdowData";
import { validationManageLeadForm } from "../functions/LeadValidations";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { addLead } from "../../../data/ApiEndpoints";
import { toast } from "react-toastify";
import FormProfile from "../common/FormProfile";
import CloseSubmitBtn from "../../common-components/custom-comps/CloseSubmitBtn";
// import { convertStraight } from "../../common-data/Converts";
// import LeadProfileInfo from "../fully-customised/LeadProfileInfo";

const ManageLeadForm = ({
  userInfoData,
  rowData,
  callFunction,
  closeModal,
  followupStage,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const {
    lead_id: leadId,
    // expected_closure_date: prevExpectedClosureDate,
    // lead_type: leadType,
  } = rowData || {};

  const iniFormValues = {
    selLeadStatus: "",
    remarks: "",
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const onChangeInput = (e) => {
    const { name, value } = e.target;

    setFormValues((prevs) => ({
      ...prevs,
      [name]: value,
    }));
    setIsSubmit(false);
  };

  const onChangeDropdown = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSumitForm = (e) => {
    e.preventDefault();

    setFormErrors(validationManageLeadForm(formValues));
    setIsSubmit(true);
  };

  const handleManageLead = async (payload) => {
    const method = "PUT";
    const endpoint = addLead;
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      console.log("Lead Add=> ", result);

      if (result?.payload?.status) {
        setIsSubmit(false);
        closeModal();
        callFunction();
        toast.success(result?.payload?.message || "Success!");
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making PUT request:", error);
    }
  };

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const userData = {
        uid: rowData?.uid,
        lead_id: leadId,
        added_by: userInfoData?.uid || userInfoData?.user_id,
        lead_status: formValues.selLeadStatus?.value,
        remarks: formValues.remarks,
      };

      const handleConfirm = async () => {
        handleManageLead(userData);
      };

      showConfirmAlert(handleConfirm, `Are you sure about closing this lead!`);
    }
  }, [isSubmit, formErrors]);

  return (
    <div className="form-container">
      <div className="profile-form-info">
        <FormProfile rowData={rowData} />
      </div>

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox disabled">
            <label htmlFor="followupStage" className={`formInputLabel`}>
              Follow-up Stage
            </label>

            <input
              type="text"
              className="formInput"
              name="followupStage"
              placeholder={`${followupStage || "NA"}`}
              disabled
            />
          </div>

          <>
            {/* <div className="formInputBox disabled">
              <label
                htmlFor="prevExpectedClosureDate"
                className={`formInputLabel`}
              >
                Previous Expected closure Date
              </label>

              <input
                type="text"
                className="formInput"
                name="prevExpectedClosureDate"
                placeholder={`${
                  prevExpectedClosureDate
                    ? convertStraight(prevExpectedClosureDate)
                    : "NA"
                }`}
                disabled
              />
            </div> */}
          </>

          {/* <div className="formInputBox disabled">
            <label htmlFor="leadType" className={`formInputLabel`}>
              Lead Type
            </label>

            <input
              type="text"
              className="formInput"
              name="leadType"
              placeholder={`${leadType?.replace(/_/g, " ") || "NA"}`}
              disabled
            />
          </div> */}

          <div className="formInputBox">
            <label htmlFor="selLeadStatus" className={`formInputLabel`}>
              Lead Status <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selLeadStatus ? "formError" : ""
              }`}>
              <SelectDropdown
                options={leadCloseStatus}
                selectedOption={formValues.selLeadStatus}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selLeadStatus", selectedValue)
                }
                name="Lead Status"
                preventKeyboardOpen={true}
              />
            </div>
          </div>

          <div className="formInputBox span2">
            <label htmlFor="remarks" className="formInputLabel">
              Remarks (Max 20 Characters - {formValues.remarks?.length || 0}){" "}
              <span className="required">*</span>
            </label>

            <textarea
              name="remarks"
              className={`formInput ${formErrors.remarks ? "formError" : ""}`}
              placeholder="Enter Remarks"
              value={formValues.remarks}
              onChange={onChangeInput}></textarea>
          </div>
        </div>

        <CloseSubmitBtn
          closeLabel="Cancel"
          submitLabel="Submit"
          onClose={closeModal}
          onSubmit={onSumitForm}
          isLoading={postPutLoading}
        />
        {/* <div className="formButtons" style={{ justifyContent: "flex-end" }}>
          <Button className="saveBtn" variant="danger" onClick={onSumitForm}>
            {postPutLoading ? <Loader /> : "Submit"}
          </Button>
        </div> */}
      </form>
    </div>
  );
};

export default ManageLeadForm;
